import React, { useState, useEffect } from "react";
// import Hamburger from "./components/Hamburger";
// import SideNav from "./components/SideNav";
// import Home from "./Home";
// import ScrollTopButton from "./components/ScrollTopButton";
// import { Link, Redirect } from "found";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./SettingsPage.css";
import backIcon from "./icons/keyboard_backspace-24px.svg";
import {
    createRefetchContainer,
    createFragmentContainer,
    graphql,
} from "react-relay";
import { updateLocalSetting } from "./Environment";
import SubscriptionList from "./SubscriptionList";
import { Modal } from "./components/Modal";
import ChangePasswordMutation from "./mutations/ChangePasswordMutation";
import { useTheme } from "./contexts/ThemeContext";
import AccountDetailsContainer from "./AccountDetailsContainer";
import { commitLocalUpdate } from "react-relay";
import environment from "./Environment";

// import loadable from '@loadable/component';
// const AccountDetailsContainer = loadable(() => import('./AccountDetailsContainer'));
// const SubscriptionList = loadable(() => import('./SubscriptionList'));

function SettingsPage(props) {
    const [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);

    const [isModalActive, setIsModalActive] = useState(false);
    const [selectedSubId, setSelectedSubId] = useState("");
    const [selectedSubName, setSelectedSubName] = useState("");
    const [isSubManage, setIsSubManage] = useState(false);
    const [subListView, setSubListView] = useState(true);
    const [profileView, setProfileView] = useState(false);
    const [accountView, setAccountView] = useState(false);
    const [isPasswordChange, setIsPasswordChange] = useState(false);
    const [status, setStatus] = useState("");

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [rePassword, setRePassword] = useState("");

    const [style, setStyle] = useState({
        modal: {
            width: "24rem",
            height: "auto",
        },
        newTextBox: {
            display: "block",
        },
    });

    const theme = useTheme();

    const { email, isPremium } = props.user;
    const {
        isAuthenticated,
        userId,
        isNavActivated,
        selectedSourceId,
        isSubListView,
        isProfileView,
        isAccountView,
    } = props.settings;

    // console.log(isAccountView);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = (e) => {
        e.preventDefault();

        if (window.pageYOffset + 500) {
            setScrolled(window.pageYOffset + 500);
        }
    };

    const content = () => <div> Content </div>;

    function onSubViewClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAccountView");
            record.setValue(true, "isSubListView");
            record.setValue(false, "isProfileView");
        });
    }

    function onProfileViewClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isAccountView");
            record.setValue(false, "isSubListView");
            record.setValue(true, "isProfileView");
        });
    }

    function onAccountViewClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAccountView");
            record.setValue(false, "isSubListView");
            record.setValue(false, "isProfileView");
        });
    }

    function onChangePasswordClick(e) {
        e.preventDefault();
        setIsPasswordChange(true);
    }

    function onCancelChangePassword(e) {
        e.preventDefault();
        setIsPasswordChange(false);
        setCurrentPassword("");
        setNewPassword("");
        setRePassword("");
    }

    function onSubmit(e) {
        e.preventDefault();
        // console.log(props.allSources);
        // console.log("Submited source search!");
    }

    function onChange(e) {
        e.preventDefault();
    }

    function onAddClick(e) {
        e.preventDefault();
        setIsModalActive(true);
        setSelectedSubId(e.target.dataset.id);
        setSelectedSubName(e.target.dataset.name);
    }

    function onCurrentPasswordChange(e) {
        e.preventDefault();
        setCurrentPassword(e.target.value);
    }

    function onNewPasswordChange(e) {
        e.preventDefault();
        setNewPassword(e.target.value);
    }

    function onRePasswordChange(e) {
        e.preventDefault();
        setRePassword(e.target.value);
    }

    function onResetPasswordSubmit(e) {
        e.preventDefault();
        console.log(currentPassword);
        console.log(newPassword);
        console.log(rePassword);


        if (newPassword != rePassword) {
            setStatus("Passwords do not match!");
            setNewPassword("");
            setRePassword("");
        } else {
            if (newPassword != "") {
                ChangePasswordMutation(currentPassword, newPassword, () => {
                    setStatus("Changed password successfully!");
                });
            } else {
                setStatus("Password cannot be empty!");
            }

            setIsPasswordChange(false);
            setStatus("Changed Password!");
        }
    }

    const _refetch = () => {
        props.relay.refetch(
            { userId: userId },
            null,
            () => {
                console.log("Refetched!");
            },
            { force: true }
        );
    };

    function onRefreshClick(e) {
        e.preventDefault();
        // _refetch();
    }

    // useEffect(() => {
    // 	return () => {
    // 		updateLocalSetting("sourceString", "kjaslkdjflkasjdfh");
    // 	};
    // });

    let showHeader = scrolled > coords ? "true" : "false";

    return (
        <div className={`settings-page-container theme-${theme.light}`}>
            <div
                className={`main-settings-header header settings-header-fixed-true theme-${theme.light}`}
            >
                <div
                    className={`main-settings-header-room settings-header-room-true theme-${theme.borderBottom} theme-${theme.light}`}
                >
                    <div className={`settings-header-controls`}>
                        <Link to="/home">
                            {" "}
                            <img className="back-icon" src={backIcon} />{" "}
                        </Link>
                    </div>
                </div>
            </div>
            <div className={`settings-body`}>
                <div className="settings-heading">
                    <h2 className={`theme-${theme.paragraph}`}>Settings</h2>
                </div>

                <div className="settings-tabview">
                    <button
                        className={`theme-${theme.paragraph} settings-link-button settings-link-button-${isSubListView} settings-link-button-${isSubListView}`}
                        onClick={onSubViewClick}
                    >
                        {" "}
                        Subscriptions{" "}
                    </button>
                    <button
                        onClick={onProfileViewClick}
                        className={`settings-link-button settings-link-button-${isProfileView} theme-${theme.paragraph}`}
                    >
                        Profile
                    </button>{" "}
                    <button
                        onClick={onAccountViewClick}
                        className={`settings-link-button settings-link-button-${isAccountView} theme-${theme.paragraph}`}
                    >
                        {" "}
                        Account
                    </button>{" "}
                </div>
                <div className="settings-section">
                    <div>
                        <div className="settings-content"></div>
                        {isSubListView ? (
                            <div>
                                <SubscriptionList
                                    refetch={_refetch}
                                    subs={props.user_Subscription}
                                    user={props.user}
                                    settings={props.settings}
                                />
                            </div>
                        ) : null}
                    </div>
                    <div>
                        {isProfileView ? (
                            <div>
                                <p
                                    className={`settings-content theme-${theme.paragraph}`}
                                >
                                    {" "}
                                    Email: {email}{" "}
                                </p>
                                {!isPasswordChange ? (
                                    <div className="settings-change-password-button-container">
                                        <button
                                            className="btn-action"
                                            onClick={onChangePasswordClick}
                                        >
                                            {" "}
                                            Change Password{" "}
                                        </button>
                                    </div>
                                ) : null}

                                <div>
                                    {isPasswordChange ? (
                                        <div
                                            className={`new-password-container`}
                                        >
                                            <form
                                                onSubmit={onResetPasswordSubmit}
                                            >
                                                <div
                                                    className={`current-password`}
                                                >
                                                    <label htmlFor="current-password">
                                                        {" "}
                                                        Current Password{" "}
                                                    </label>
                                                    <input
                                                        value={currentPassword}
                                                        onChange={
                                                            onCurrentPasswordChange
                                                        }
                                                        className={`standard-textfield-small`}
                                                        id="current-password"
                                                        type="password"
                                                    />
                                                </div>
                                                <div className={`new-password`}>
                                                    <label htmlFor="new-password">
                                                        {" "}
                                                        New Password{" "}
                                                    </label>
                                                    <input
                                                        value={newPassword}
                                                        onChange={
                                                            onNewPasswordChange
                                                        }
                                                        className={`standard-textfield-small`}
                                                        id="new-password"
                                                        type="password"
                                                    />
                                                </div>
                                                <div className={`re-password`}>
                                                    <label htmlFor="re-password">
                                                        {" "}
                                                        Re-enter Password{" "}
                                                    </label>
                                                    <input
                                                        value={rePassword}
                                                        onChange={
                                                            onRePasswordChange
                                                        }
                                                        className={`standard-textfield-small`}
                                                        id="re-password"
                                                        type="password"
                                                    />
                                                </div>
                                                <div>
                                                    <input
                                                        type="button"
                                                        value="Cancel"
                                                        onClick={
                                                            onCancelChangePassword
                                                        }
                                                        className="btn-action"
                                                    />
                                                    <input
                                                        type="submit"
                                                        className="btn-action"
                                                        value="Submit"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}

                        <p>{status}</p>
                    </div>

                    <div>
                        {" "}
                        {isAccountView ? (
                            <div>
                                <h3 className={`account-settings-headline theme-${theme.paragraph}`}>
                                    {" "}
                                    Account Settings{" "}
                                </h3>
                                <AccountDetailsContainer
                                    settings={props.settings}
                                    user={props.user}
                                    title={`Manage Account`}
                                    style={{ color: "blue" }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default createRefetchContainer(
    SettingsPage,
    {
        user_Subscription: graphql`
            fragment SettingsPage_user_Subscription on SubscriptionNodeConnection {
                edges {
                    node {
                        id
                        name
                        source {
                            id
                            source_icon
                        }
                        parent {
                            id
                        }
                    }
                }
            }
        `,
    },
    graphql`
        query SettingsPage_RefetchQuery($userId: ID) {
            subscriptions(user: $userId) {
                ...SettingsPage_user_Subscription
            }
        }
    `
);
